var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.type === 'ELECTRICITY_DYNAMIC')?_c('InfoBox',{attrs:{"title":_vm.$t('ecDynamic.title')}},[_vm._v(" "+_vm._s(_vm.$t('ecDynamic.body'))+" ")]):_vm._e(),(_vm.type === 'ELECTRICITY_DYNAMIC_WITH_PV')?_c('InfoBox',{attrs:{"title":_vm.$t('ecDynamicWithPv.title')}},[_vm._v(" "+_vm._s(_vm.$t('ecDynamicWithPv.body'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }